import { A } from '@solidjs/router';
import { ErrorCatcher } from '../../../tools/error-catcher';
import clsx from 'clsx';
import { WrappedImage } from '../../image-component/wrapped-image';
import { Show } from 'solid-js';
import { ImageWordpress } from '../../../types/shared';

export const ReadMoreItem = (props: ReadMoreItemType) => {
    
    return (
        <ErrorCatcher componentName="ReadMoreItem">
            <Show when={props.permalink}>
                <article class="post-list-item">
                    <A class="group" href={props.permalink}>
    
                        <div class={clsx('mb-s', 'tablet:mb-[1.25rem]')}>
                            <div>
                                {props.featuredImage ? (
                                    <WrappedImage width={300} renderWidth={'100%'} height={'auto'} aspectRatio={'wide'} image={props.featuredImage} classes={'post-list-item-image group-hover:scale-105 ease-in-out duration-300'} />
                                ) : (
                                    <div class="aspect-video max-w-[300px]" />
                                )}
                            </div>
                        </div>
                        <h3 class={clsx('mb-[0.25em]', 'text-headerL', 'font-paytone', 'w-full', 'max-w-textMaxWidth', 'tablet:text-headerS' )}>
                            {props.postTitle}
                        </h3>
                        {props.preamble && (
                            <p
                                class={clsx('w-full', 'max-w-textMaxWidth', 'text-left', 'text-paragraphM', 'mb-[1em]', 'tablet:text-paragraphS'
                                )}
                            >
                                {props.preamble}
                            </p>
                        )}

                    </A>
                </article>
            </Show>
        </ErrorCatcher>
    );
};

export type ReadMoreItemType = {
    featuredImage: ImageWordpress;
    permalink: string;
    postTitle: string;
    preamble: string;
};
